import ContactLayout from "Layout/ContactLayout";
import FeaturedProperty from "components/FeaturedProperty";

export default function Properties() {
  return (
    <ContactLayout heading="Find Exclusive properties">
      <FeaturedProperty />
    </ContactLayout>
  );
}
